const autocompleteFormEquip = {
  local: 'Place',
  equipment: 'Equipment',
  area: 'Department',
  company: 'Third party companies',
  equipInfo: 'Equipment Details',
  equipmentAttachments: 'Equipment Attachments',
  equipmentModelAttachments: 'Equipment Model Attachments',
  noAttachments: 'No attachments available',
};

export default autocompleteFormEquip;
